module.exports = __webpack_public_path__ + "img/sel_Chengdu-.f6e3eeec.png";